import React from "react";
import { ArrowLeftOutlined, HistoryOutlined } from "@ant-design/icons";
import JoinLecture from "Pages/MyScheduleBeta/LectureDetails/CommonComponents/JoinLecture";
import { inBetweenTime } from "utilFunctions/shared/ScheduleStatus";
import { isShowJoinLectureButton } from "Pages/MyScheduleBeta/utils/layoutHelpers";
import { getLectureHeading } from "Pages/MyScheduleBeta/LectureDetails/LectureTypes";

export interface NavTab {
  id: string;
  label: string;
  icon: React.ReactNode;
}

interface LectureHeaderProps {
  lecture: any;
  activeTab: string;
  setActiveTab: (id: string) => void;
  navTabs: NavTab[];
  onBack: () => void;
}

const LectureHeader: React.FC<LectureHeaderProps> = ({
  lecture,
  activeTab,
  setActiveTab,
  navTabs,
  onBack,
}) => {
  const heading = getLectureHeading(lecture);

  const getComputedStatus = (lecture: any) => {
    if (inBetweenTime(lecture?.startTime, lecture?.endTime)) {
      return "Ongoing";
    }

    if (
      lecture?.syllabusStatus &&
      lecture.syllabusStatus.toUpperCase() === "NA"
    ) {
      return "";
    }

    if (lecture?.syllabusStatus) {
      return lecture.syllabusStatus;
    }

    return "";
  };

  const computedStatus = getComputedStatus(lecture);
  const message = ["PTM", "ORIENTATION"].includes(lecture.eventType)
    ? "Join Meeting"
    : "Join Lecture";
  return (
    <div
      className="desktop-header"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        padding: "24px 28px 0px 28px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "16px",
          minHeight: "90px",
        }}
      >
        <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
          <ArrowLeftOutlined
            onClick={onBack}
            style={{
              fontSize: "18px",
              color: "#374151",
              cursor: "pointer",
              marginTop: "4px",
              padding: "4px",
              flexShrink: 0,
            }}
          />

          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontStyle: "normal !important",
                }}
              >
                {heading}
              </h1>
              <span
                style={{
                  backgroundColor:
                    computedStatus === "ONGOING"
                      ? "#e6f4ea"
                      : computedStatus === "UPCOMING"
                      ? "#e8f0fe"
                      : "#f3f4f6",
                  color:
                    computedStatus === "ONGOING"
                      ? "#137333"
                      : computedStatus === "UPCOMING"
                      ? "#1a73e8"
                      : "#6b7280",
                  fontSize: "11px",
                  fontWeight: 700,
                  padding: "3px 10px",
                  borderRadius: "12px",
                }}
              >
                ● {computedStatus}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                gap: "16px",
                marginTop: "8px",
                fontSize: "12px",
                color: "var(--primary-text)",
                fontWeight: 600,
              }}
            >
              <span>Lecture ID : {lecture?.batchTimeTableId}</span>
              <span>Batch Name: {lecture?.batchName}</span>
            </div>

            {activeTab === "attendance" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginTop: "6px",
                  fontSize: "12px",
                  color: "#9ca3af",
                }}
              >
                <HistoryOutlined style={{ fontSize: "12px" }} />
                <span>
                  Last updated by {lecture?.updatedByEmail} ·{" "}
                  {lecture?.updatedAt}
                </span>
              </div>
            )}
          </div>
        </div>

        {isShowJoinLectureButton(event) && (
          <JoinLecture eventLink={lecture.eventLink} message={message} />
        )}
      </div>

      <div
        style={{
          display: "flex",
          gap: "32px",
          marginTop: "24px",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        {navTabs.map((tab) => (
          <div
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              paddingBottom: "12px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: activeTab === tab.id ? 700 : 500,
              color: activeTab === tab.id ? "var(--primary-text)" : "#6b7280",
              borderBottom:
                activeTab === tab.id
                  ? "3px solid var(--primary-text)"
                  : "3px solid transparent",
            }}
          >
            {tab.icon} {tab.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LectureHeader;
